module.exports = __webpack_public_path__ + "img/landscape_11.59879f4c.jpg";